module.exports = __webpack_public_path__ + "static/media/441970458_459499383335906_1988265925095290214_n.710a769b.jpg";